module.exports = __webpack_public_path__ + "static/media/Годишен отчет 2023.54eea38e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2024/Годишен отчет 2023.pdf
// module id = 91
// module chunks = 0